export default "__VITE_ASSET__CZlzYZRL__"